import { getHighcharts } from "@highcharts/react";

const initHighcharts = (lang: Highcharts.LangOptions) => {
  getHighcharts().setOptions({
    lang,
    palette: {
      colorScheme: "light",
      light: {
        backgroundColor: "#ffffff",
      },
    },
    credits: {
      enabled: false,
    },
  });
};

export default initHighcharts;
